module.exports = __webpack_public_path__ + "img/ปลาลิ้นหมา.690646ea.jpg";